import { createStore } from 'vuex';
import createVuexPersistedState from 'vuex-persistedstate';
import { LOCAL_STORAGE_KEY } from '@/utils/const';
import account from '@/store/modules/account';
import activityLog from './modules/activity_log';
import dashboard from './modules/dashboard';
import organization from './modules/organization';
import error from './modules/error';
import user from './modules/user';
import routerLoader from './modules/router_loader';
import screen from './modules/screen';
import sidenav from './modules/sidenav';
import supportSession from './modules/support_session';
import ticket from './modules/ticket';
import ticketComment from './modules/ticket_comment';


export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    activityLog,
    dashboard,
    error,
    organization,
    routerLoader,
    screen,
    sidenav,
    supportSession,
    ticket,
    ticketComment,
    user
  },
  plugins: [
    createVuexPersistedState({
      key: LOCAL_STORAGE_KEY,
      storage: window.localStorage,
      // The support session too, so a reload brings its desktop back.
      paths: ['account', 'supportSession.supportSession.session'],
    }),
  ],
});
